var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAflacAccountLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4793_76900)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.4167H0V12.25H14V13.4167Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 0.583252H13.4167V12.8333H12.25V1.74992H6.41667V12.8333H5.25V0.583252Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.583496 4.08325H5.8335V5.24992H1.75016V12.8333H0.583496V4.08325Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1665,
    y: 2.9165,
    width: 2.33333,
    height: 1.16667,
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1665,
    y: 5.25,
    width: 2.33333,
    height: 1.16667,
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1665,
    y: 7.58325,
    width: 2.33333,
    height: 1.16667,
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1665,
    y: 9.9165,
    width: 2.33333,
    height: 1.16667,
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4793_76900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAflacAccountLogo);
export default __webpack_public_path__ + "static/media/aflac-account-logo.462392cc654017aa71c336bb266bab09.svg";
export { ForwardRef as ReactComponent };